import React, { Component } from 'react';
import GoogleAnalytics from 'react-ga';
import ReactGA from "react-ga4";
import { connect } from 'react-redux';
import { getMyProfile } from './actions/user';
import {check as loggedIn} from './utils/tokenUtils'

if (localStorage.getItem('RecommendedCookies') === '1') {
  GoogleAnalytics.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS);
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_GA4);
}

const withTracker = (WrappedComponent, options = {}) => {
    const trackPage = async (page, profile, currentOutlet) => {
      setTimeout(() => {
        sendGA4PageView(page, profile, currentOutlet);
        sendUAPageView(page, profile, currentOutlet);
      }, 1000);
    };

    const sendGA4PageView = (page, profile, currentOutlet) => {
        const eventParameters = {
          hitType: 'pageview',
          page: page,
          profile_id: profile.id,
          user_group_id: profile.attributes['user-group-id'],
          psuedo_login: profile.attributes['psuedo-login'] || false,
          customer_number: currentOutlet.customer_number,
          county: currentOutlet.county,
          rdr_code: currentOutlet.rdr_code,
          pay_for_performance: currentOutlet.pay_for_performance,
          supply_type: currentOutlet.supply_type
        };
        ReactGA.send(eventParameters);
    };

    const sendUAPageView = (page, profile, currentOutlet) => {
        GoogleAnalytics.pageview(page);
        GoogleAnalytics.set({ dimension1: profile.id });
        GoogleAnalytics.set({ dimension2: profile.attributes['user-group-id'] });
        GoogleAnalytics.set({ dimension3: profile.attributes['psuedo-login'] });
        GoogleAnalytics.set({ dimension4: currentOutlet.customer_number });
        GoogleAnalytics.set({ dimension5: currentOutlet.county });
        GoogleAnalytics.set({ dimension6: currentOutlet.rdr_code });
        GoogleAnalytics.set({ dimension7: currentOutlet.pay_for_performance });
        GoogleAnalytics.set({ dimension8: currentOutlet.supply_type });
    }

    const HOC = class extends Component {
      getMyProfileThenTrackPage = async (page) => {
        this.props.dispatch(getMyProfile()).then(() => {
          trackPage(page, this.props.profile, this.props.currentOutlet);
        }).catch(error => {
          console.log(error);
        });
      }

      componentDidMount() {
        if (loggedIn()) {
          this.getMyProfileThenTrackPage(this.props.location.pathname);
        }
      }

      componentWillReceiveProps(nextProps) {
        const currentPage = this.props.location.pathname;
        const nextPage = nextProps.location.pathname;

        if (currentPage !== nextPage) {
          if (!loggedIn() || this.props.profile.id) {
            trackPage(nextPage, this.props.profile, this.props.currentOutlet);
          } else {
            this.getMyProfileThenTrackPage(nextPage);
          }
        }
      }

      render() {
        return <WrappedComponent {...this.props} />;
      }
    };

    const mapStateToProps = (state) => {
      return {
        profile: state.currentUser.profile,
        currentOutlet: state.currentUser.profile.attributes['current-outlet'] || {}
      };
    };

    return connect(mapStateToProps)(HOC);
};

export default withTracker;



// WEBPACK FOOTER //
// ./src/withTracker.js